<div id="form" class="example-container">
  <div id="hauptcontent">
    <app-registrierung-formular #formular></app-registrierung-formular>
  </div>
</div>
